export default __webpack_public_path__ + "static/media/userIcon.0e205611.svg";